import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Widgets1 from '../../../Common/CommonWidgets/Widgets1';
import SocialWidget from '../../../Common/CommonWidgets/SocialWidget';
import axios from 'axios';
import config from '../../../../config';
import visitors from '../../../../assets/images/logo/visitors.png';
import male from '../../../../assets/images/logo/male.png';
import female from '../../../../assets/images/logo/female.png';
import child from '../../../../assets/images/logo/child.png';
import { useTranslation } from 'react-i18next';



const WidgetWrapper = ({ propertyId, startDate, endDate }) => {
  const { t } = useTranslation();
  const token = localStorage.getItem('sessiontoken');
  const configheader = {
    headers: {
      Authorization: `${token}`
    }
  };

  const concessionaire_id = localStorage.getItem('concessionaireId');  
  const property_access = localStorage.getItem("propertyAccess");

  // The API returns null for a metric it can't compute over this window —
  // no sales rows, no footfall rows, or a ratio missing one of its two halves.
  // Zero would read as a measurement; a dash reads as "no data", which is what
  // it is.
  const PLACEHOLDER = '—';
  const fmt = (v) => (v === null || v === undefined || v === '' ? PLACEHOLDER : Number(v).toLocaleString());
  const fmtPct = (v) => (v === null || v === undefined || v === '' ? PLACEHOLDER : `${Number(v).toLocaleString()}%`);

  const EMPTY = {
    traffic: null,
    sales: null,
    conversion: null,
    atv: null,
    shopperYield: null,
    demographics: {},
    coverage: null,
  };

  const [data, setData] = useState(EMPTY);

  const [hasDemographics, setHasDemographics] = useState(false);

  useEffect(() => {
    setData(EMPTY);

    axios
      .post(
        `${config.hostname}/trafficdashboard/getdetails`,
        {
          concessionaire_id,
          property_id: propertyId,
          start_date: startDate,
          end_date: endDate,
          property_access:property_access,
        },
        configheader
      )
      .then(response => {
        const res = response.data;
        // Kept raw — formatting happens at render so nulls survive the trip.
        setData({
          traffic: res.totalTraffic,
          sales: res.totalNetSales,
          conversion: res.conversion,
          atv: res.atv,
          shopperYield: res.shopperYield,
          demographics: res.demographics || {},
          coverage: res.coverage || null,
        });
      })
      .catch(() => {
        setData(EMPTY);
      });
  }, [propertyId, startDate, endDate]);

  useEffect(() => {
    setHasDemographics(Object.keys(data.demographics).length > 0);
  }, [data.demographics]);

  // KPI widgets
  const coreWidgets = [
    { title: t('Traffic'), total: fmt(data.traffic), color: 'primary', icon: 'customers' },
    { title: t('Sales'), total: fmt(data.sales), color: 'secondary', icon: 'profit' },
    { title: t('Conversion'), total: fmtPct(data.conversion), color: 'success', icon: 'sale' },
    { title: t('ATV'), total: fmt(data.atv), color: 'warning', icon: 'course-1' },
    { title: t('Shopper Yield'), total: fmt(data.shopperYield), color: 'primary', icon: 'course-2' }
  ];

  // One line explaining a row of dashes. Which half is missing decides who has
  // to act — the sales import or the people-counter feed.
  const cov = data.coverage;
  let coverageNote = '';
  if (cov && !cov.hasSales && cov.hasFootfall) coverageNote = t('No sales reported for this period');
  else if (cov && cov.hasSales && !cov.hasFootfall) coverageNote = t('No footfall recorded for this period');
  else if (cov && !cov.hasSales && !cov.hasFootfall) coverageNote = t('No sales or footfall data for this period');

  // Demographic widgets
  const demographicWidgets = Array.isArray(data.demographics)
    ? data.demographics.map((item) => {
        let categoryImage = visitors; 
        const title = item.category?.toLowerCase();

        if (title.includes('female')) categoryImage = female;      
        else if (title.includes('male')) categoryImage = male;
        else if (title.includes('child')) categoryImage = child;
        else categoryImage = visitors;

        return {
          title: item.category,
          image: categoryImage,
          total: Number(item.count).toLocaleString(),
          subTitle: t('{{percentage}}% of Visitors', { percentage: item.percentage }),
          status: 'success',
          chart: {
            color: ['#46a2dbff'], // blue accent
            series: [item.percentage],
          },
        };
      })
    : [];
  return (
    <Row>
      {/* KPIs Card */}
      <Card className="mb-3">
        <CardBody>
          <Row>
            {coreWidgets.map((widget, idx) => (
              <Col key={idx}>
                <Widgets1 data={widget} />
              </Col>
            ))}
          </Row>
          {coverageNote && (
            <div className="text-muted f-12 mt-2">{coverageNote}</div>
          )}
        </CardBody>
      </Card>

      {/* Demographics Card */}
      {hasDemographics && (
        <Card>
          <CardBody>            
            <h5 className="mb-0">{t('Demographics')}</h5>
            <Row>
              {demographicWidgets.map((item, i) => (
          <Col xl="3" sm="6" key={i}>
            <SocialWidget data={item} />
          </Col>
        ))}
            </Row>
          </CardBody>
        </Card>
      )}
    </Row>
  );
};

export default WidgetWrapper;
